module.exports = __webpack_public_path__ + "img/tip6.550805e7.png";